import { useFeatureIsOn, useFeatureValue } from '@growthbook/growthbook-react'

import { isTestGroup } from 'helpers/isTestGroup'

import { GROWTHBOOK_FEATURE_KEY, TEST_SEGMENTS } from 'root-constants'

export const useExperimentalFeatures = () => {
  const isBlessedPathOnboardingTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.BLESSED_ONBOARDING_2271_TEST,
  )

  const isAyahPath313RedirectQuizTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.AYAH_313_NEW_QUIZ_TEST,
  )

  const isKarmaPath13DuomoPaywallTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.KARMA_13_DUOMO_PAYWALL_TEST,
  )

  const isBlessedPath2271CLowerPricesTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.BLESSED_2271_C_LOWER_PRICES_TEST,
  )

  const isKarmaPath13C7d1mSubTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.KARMA_13_C_7D_1M_SUB_TEST,
  )

  const isKarmaPath13C3dTrialTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.KARMA_13_KP_BS_13_C_3D_TRIAL_TEST,
  )

  const isBlessedPath2271C3TrialTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.BLESSED_2271_C_3D_TRIAL_TEST,
  )

  const isBlessedPath2271Monetization2248Test = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.BLESSED_2271_2248_MONETIZATION_TEST,
  )

  const isKarma17NewQuestionFormatTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.KARMA_17_KP_BS_13_C_NEW_FORMAT_TEST,
  )

  const isKarmaPrimerCreditCardActive = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.KARMA_PRIMER_CARD_ACTIVE_TEST,
  )

  const isBlessedPrimerCreditCardActive = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.BLESSED_PRIMER_CARD_ACTIVE_TEST,
  )

  const isAyahPrimerCreditCardActive = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.AYAH_PRIMER_CARD_ACTIVE_TEST,
  )

  const isKarma27MultiStrugglesTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.KARMA_27_MULTISELECT_STRUGGLES_TEST,
  )

  const isKarma28HiddenProfileTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.KARMA_28_WTYPE_HIDDEN_PROFILE_TEST,
  )

  const isKarmaPayPalPriorityTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.KARMA_34_PAYPAL_PRIORITY_TEST,
  )

  const isKarma36IntroPriceSelect = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.KARMA_36_INTRO_PRICE_SELECT_TEST,
  )

  const isAyah39ScreenWordingTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.AYAH_39_1_SCREEN_WORDING,
  )

  const isAyah42FirstScreenVariant = useFeatureValue(
    GROWTHBOOK_FEATURE_KEY.AYAH_42_FLOW_AYAH_314_1SCRN_LOADER,
    TEST_SEGMENTS.VARIANT_A,
  )

  const ayah44BreakScreenVariant = useFeatureValue(
    GROWTHBOOK_FEATURE_KEY.AYAH_44_BREAK_SCREEN,
    TEST_SEGMENTS.VARIANT_A,
  )

  const ayah46StickyPaymentsVariant = useFeatureValue(
    GROWTHBOOK_FEATURE_KEY.AYAH_46_STICKY_PAYMENTS,
    TEST_SEGMENTS.VARIANT_A,
  )

  const isAyah5528DaysTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.AYAH_55_28_DAYS_TEST,
  )

  const isAyah56Test = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.AYAH_56_3_MONTH_SUB_TEST,
  )

  const isAyah58RedirectToLwTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.AYAH_58_REDIRECT_TO_LW_TEST,
  )

  const isAyah59UpsellV2Test = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.AYAH_59_UPSELL_V2_TEST,
  )

  const isAyah47PreloadScreenTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.AYAH_47_PRELOAD_SCREEN_TEST,
  )

  const isAyah48DiscountTest = useFeatureValue(
    GROWTHBOOK_FEATURE_KEY.AYAH_48_ADDITIONAL_DISCOUNT_TEST,
    TEST_SEGMENTS.VARIANT_A,
  )

  const isAyah49FacebookParamsTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.AYAH_49_FACEBOOK_PARAMS_TEST,
  )

  const isAyah61PwSpeedTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.AYAH_61_PW_SPEED_TEST,
  )

  const isAyah65ShowArchetypeTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.AYAH_65_SD_SHOWTYPE_TEST,
  )

  const ayah83Alternative2Variant = useFeatureValue(
    GROWTHBOOK_FEATURE_KEY.AYAH_83_AP_QURAN_313_C_ALTERNATIVE2_TEST,
    TEST_SEGMENTS.VARIANT_A,
  )

  const ayah84DynamicHeadlinesTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.AYAH_84_DYNAMIC_HEADLINES_TEST,
  )

  const ayah85NewPriceVariant = useFeatureValue(
    GROWTHBOOK_FEATURE_KEY.AYAH_85_FLOW_AYAH_313_NEW_PRICE_V2_TEST,
    TEST_SEGMENTS.VARIANT_A,
  )

  const ayah93SdQuizVariant = useFeatureValue(
    GROWTHBOOK_FEATURE_KEY.AYAH_93_SD_QUIZ_VARIANT,
    TEST_SEGMENTS.VARIANT_A,
  )

  const ayah94LocalPricesVariant = useFeatureValue(
    GROWTHBOOK_FEATURE_KEY.AYAH_94_LOCAL_PRICES_TEST,
    TEST_SEGMENTS.VARIANT_A,
  )
  const isAyah94LocalPricesTestGroup =
    ayah94LocalPricesVariant === TEST_SEGMENTS.VARIANT_B

  const isAyah95WldbFirstScreenV2Test = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.AYAH_95_WLDB_FIRST_SCREEN_V2_TEST,
  )

  const ayah96FinanceScratchVariant = useFeatureValue(
    GROWTHBOOK_FEATURE_KEY.AYAH_96_FINANCE_SCRATCH_TEST,
    TEST_SEGMENTS.VARIANT_A,
  )

  const ayah98AudioUpsellVariant = useFeatureValue(
    GROWTHBOOK_FEATURE_KEY.AYAH_98_AUDIO_UPSELL_V2_TEST,
    TEST_SEGMENTS.VARIANT_A,
  )

  const ayah99FinanceFirstScreenVariant = useFeatureValue(
    GROWTHBOOK_FEATURE_KEY.AYAH_99_FINANCE_FIRST_SCREEN_TEST,
    TEST_SEGMENTS.VARIANT_A,
  )

  const isAyah103ParentingUpsellTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.AYAH_103_PARENTING_UPSELL_TEST,
  )

  const isAyah105NewPriceV2Test = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.AYAH_105_NEW_PRICE_V2_TEST,
  )

  const isAyah107WldbPaywallTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.AYAH_107_WLDB_PAYWALL_TEST,
  )

  const ayah108WldbQuizVariant = useFeatureValue(
    GROWTHBOOK_FEATURE_KEY.AYAH_108_WLDB_QUIZ_VARIANT,
    TEST_SEGMENTS.VARIANT_A,
  )

  const isAyah110MonthlyUpsellTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.AYAH_110_MONTHLY_UPSELL_TEST,
  )

  const ayah112QuranAgeVariant = useFeatureValue(
    GROWTHBOOK_FEATURE_KEY.AYAH_112_QURAN_AGE_TEST,
    TEST_SEGMENTS.VARIANT_A,
  )

  const ayah113FlowAyahQuizVariant = useFeatureValue(
    GROWTHBOOK_FEATURE_KEY.AYAH_113_FLOW_AYAH_QUIZ_VARIANT,
    TEST_SEGMENTS.VARIANT_A,
  )

  const ayah115ParentingQuizVariant = useFeatureValue(
    GROWTHBOOK_FEATURE_KEY.AYAH_115_PARENTING_QUIZ_V5,
    TEST_SEGMENTS.VARIANT_A,
  )
  const isAyah115ParentingQuizTestGroup = isTestGroup(
    ayah115ParentingQuizVariant,
  )

  const isAyah116ParentingUpiTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.AYAH_116_PARENTING_UPI_TEST,
  )

  const isAyah119OpenQuestionTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.AYAH_119_OPEN_QUESTION_TEST,
  )

  const ayah120NewPricingVariant = useFeatureValue(
    GROWTHBOOK_FEATURE_KEY.AYAH_120_NEW_PRICING_TEST,
    TEST_SEGMENTS.VARIANT_A,
  )

  const ayah123DiscountVariant = useFeatureValue(
    GROWTHBOOK_FEATURE_KEY.AYAH_123_DISCOUNT_TEST,
    TEST_SEGMENTS.VARIANT_A,
  )

  const ayah126KnowledgeExtendedVariant = useFeatureValue(
    GROWTHBOOK_FEATURE_KEY.AYAH_126_KNOWLEDGE_EXTENDED_VARIANT,
    TEST_SEGMENTS.VARIANT_A,
  )

  const isAyah128KnowledgeEmailTest = useFeatureIsOn(
    GROWTHBOOK_FEATURE_KEY.AYAH_128_KNOWLEDGE_EMAIL_TEST,
  )

  return {
    isBlessedPathOnboardingTest,
    isAyahPath313RedirectQuizTest,
    isKarmaPath13DuomoPaywallTest,
    isBlessedPath2271CLowerPricesTest,
    isKarmaPath13C7d1mSubTest,
    isKarmaPath13C3dTrialTest,
    isBlessedPath2271C3TrialTest,
    isBlessedPath2271Monetization2248Test,
    isKarma17NewQuestionFormatTest,
    isKarma27MultiStrugglesTest,
    isKarma28HiddenProfileTest,
    isKarmaPrimerCreditCardActive,
    isBlessedPrimerCreditCardActive,
    isAyahPrimerCreditCardActive,
    isKarmaPayPalPriorityTest,
    isKarma36IntroPriceSelect,
    isAyah39ScreenWordingTest,
    isAyah42FirstScreenVariant,
    ayah44BreakScreenVariant,
    ayah46StickyPaymentsVariant,
    isAyah5528DaysTest,
    isAyah56Test,
    isAyah58RedirectToLwTest,
    isAyah59UpsellV2Test,
    isAyah47PreloadScreenTest,
    isAyah61PwSpeedTest,
    isAyah48DiscountTest,
    isAyah49FacebookParamsTest,
    isAyah65ShowArchetypeTest,
    ayah83Alternative2Variant,
    ayah84DynamicHeadlinesTest,
    ayah85NewPriceVariant,
    ayah93SdQuizVariant,
    isAyah94LocalPricesTestGroup,
    isAyah95WldbFirstScreenV2Test,
    ayah96FinanceScratchVariant,
    ayah98AudioUpsellVariant,
    ayah99FinanceFirstScreenVariant,
    isAyah103ParentingUpsellTest,
    isAyah105NewPriceV2Test,
    isAyah107WldbPaywallTest,
    ayah108WldbQuizVariant,
    isAyah110MonthlyUpsellTest,
    ayah112QuranAgeVariant,
    ayah113FlowAyahQuizVariant,
    ayah115ParentingQuizVariant,
    isAyah115ParentingQuizTestGroup,
    isAyah116ParentingUpiTest,
    isAyah119OpenQuestionTest,
    ayah120NewPricingVariant,
    ayah123DiscountVariant,
    ayah126KnowledgeExtendedVariant,
    isAyah128KnowledgeEmailTest,
  }
}
